module.exports = __webpack_public_path__ + "./images/7fb676aea455f0a28dd3f4d096b57436.webp";